export default __webpack_public_path__ + "static/media/variableIcon.a5e29538.svg";